import { ShieldCheck } from 'lucide-react';

export default function Marquee({ items = [], testId = 'marquee' }) {
  const doubled = [...items, ...items];
  return (
    <div data-testid={testId} className="relative overflow-hidden border-y border-white/5 py-6 md:py-8 bg-[#07111F]">
      <div className="marquee-track animate-marquee font-poppins font-black uppercase tracking-tight text-[9vw] md:text-[6vw] leading-none">
        {doubled.map((item, i) => (
          <span key={i} className="inline-flex items-center gap-8 text-white/[0.06]">
            {item}
            <ShieldCheck className="inline-block h-[6vw] md:h-[4vw] w-auto text-[#FFD400]/20" strokeWidth={1.5} />
          </span>
        ))}
      </div>
    </div>
  );
}
